import { CartItem } from '../../../../types/Cart';

export const getProjectIdFromProject = (item: CartItem) => item.project.id;
